import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { MetodoPagamento, Venda } from 'src/app/core/models/venda';
import { ClienteService } from 'src/app/core/services/cliente.service';

@Component({
  selector: 'app-pagamento-modal',
  templateUrl: './pagamento-modal.component.html',
  styleUrls: ['./pagamento-modal.component.scss'],
})
export class PagamentoModalComponent {
  @Input() venda: Venda = new Venda();
  @Input() display: boolean = false;
  @Output() onClose = new EventEmitter();
  @Output() onConfirm = new EventEmitter<Venda>();

  discount: number = 0;
  addition: number = 0;
  receivedAmount: number = 0;
  change: number = 0;
  selectedCustomer: SelectItem | any = {};
  optionsCustomers: SelectItem[] = [];
  paymentMethods: SelectItem[] = [];
  metodoPagamentoEnum: typeof MetodoPagamento = MetodoPagamento;

  constructor(private clienteService: ClienteService) {
    const optionsPayments = Object.keys(MetodoPagamento).map((key) => {
      return {
        label: MetodoPagamento[key as keyof typeof MetodoPagamento],
        value: MetodoPagamento[key as keyof typeof MetodoPagamento], // Corrigido para enviar o valor do enum
      };
    });

    this.paymentMethods = optionsPayments;
  }

  onPaymentMethodChange() {
    if (this.venda.pagamento !== MetodoPagamento.dinheiro) {
      this.receivedAmount = 0;
      this.change = 0;
    }
  }

  calculateChange() {
    if (this.venda.pagamento === MetodoPagamento.dinheiro) {
      this.change = this.receivedAmount - this.venda.total;
    }
  }

  searchCustomer(event: any) {
    const search = event.query;
    this.clienteService.pesquisar(search).subscribe((customers) => {
      this.optionsCustomers = customers.map((c: any) => ({
        label: c.nome,
        value: c,
      }));
    });
  }

  confirmPayment() {
    const custumer = this.selectedCustomer?.value;
    if (custumer) {
      this.venda.cliente = custumer;
    }

    // Aplica discount/addition informados no modal ao objeto venda
    this.venda.desconto = Number(this.discount) || 0;
    this.venda.acrescimo = Number(this.addition) || 0;

    // Recalcula os totais da venda (subtotal, itensDesconto/itensAcrescimo)
    if (typeof (this.venda as any).recalculateTotals === 'function') {
      (this.venda as any).recalculateTotals();
    }

    // Emite a venda atualizada para o parent
    this.onConfirm.emit(this.venda);
  }

  cancelPayment() {
    this.onClose.emit();
    this.resetPaymentData();
  }

  resetPaymentData() {
    this.discount = 0;
    this.addition = 0;
    this.receivedAmount = 0;
    this.change = 0;
    this.selectedCustomer = null;
  }
}
